import React, {useState, useEffect}  from 'react';
import { getRacerDetails, removeLookingFor, getLookingForSearches, addLookingForSearches, updateLookingForSearchable } from './helpers/apihandler';

function LookingFor({walletAddress, setModalInfo, racerArray}) {

    const [searchFields, setSearchFields] = useState([[],[]]);
	const [currLF, setCurrLF] = useState([[],[]]);
    const [racerSearchable, setRacerSearchable] = useState(false);
    const [allRacers, setAllRacers] = useState([]);

    useEffect(() => {
        const getAllRacers = async() => {
            let racersTemp = await getRacerDetails();
            console.log(racersTemp);
            console.log(racerArray);
            let creatures = [];
            let skins = [];
            for (let x = 0; x < racersTemp.length; x++){
            if (!creatures.includes(racersTemp[x].Creature)){
                creatures.push(racersTemp[x].Creature);
            } 
            if (!skins.includes(racersTemp[x].Phant_Skin)){
                skins.push(racersTemp[x].Phant_Skin);
            }
            }
            setSearchFields([creatures.sort(),skins.sort()]);
            setAllRacers(racersTemp);
        }

        getAllRacers();
        getSearches();
    },[racerArray])

	const updateSearchableRacers = async(e) => {
		const updateResults = updateLookingForSearchable(walletAddress,e.target.checked);
		if (updateResults.result === "success"){
			setRacerSearchable(e.target.checked);
		}else{
			setModalInfo("Error updating transfer status. please try again.");
			
		}
	}


	const addLookingFor = async() => {
		let creature = document.getElementById('availablecreatures').value;
		let skin = document.getElementById('availableskins').value;
		const updateResults = await addLookingForSearches(walletAddress, creature,skin);
		if (updateResults.result === "success"){
			setCurrLF([[],[]]);
			getSearches();
		}else{
			setModalInfo("Error adding new search criteria. please try again.");
		}
	}

	const getSearches = async () => {
	
		if (currLF[0].length > 0 || currLF[1].length > 0 || walletAddress === '') {
			return;
		}
		const searchData = await getLookingForSearches(walletAddress);
	
		setCurrLF([searchData.mysearches, searchData.othersearches]);
		
	}

	const remLookingFor = async(id) => {
		const updateResults = await removeLookingFor(walletAddress, id);
		if (updateResults.result === "success"){
		setCurrLF([[],[]]);
		getSearches()
		}else{
			setModalInfo("Error removing Looking For. please try again.");
		}
	}

    return (
        <div>
            <div style={{display:'none'}}>Allow your racers to be searchable? <input type="checkbox" checked={racerSearchable} onChange={(e) => updateSearchableRacers(e)} style={{width:'15px'}}/></div>
            <div>Create Search Request(select one or both options):</div> <div>Creature: <select id="availablecreatures"><option value="">Choose Creature</option>{searchFields[0].map(function(creat, i) { return <option key={i} value={creat}>{creat}</option>})}</select> 
            Phant Skin: <select id="availableskins"><option value="">Choose Skin</option>{searchFields[1].map(function(skins, i) { return <option key={i} value={skins}>{skins}</option>})}</select><input type='button' value='Add' style={{width:'50px'}} onClick={() => addLookingFor()}/></div>
            <div style={{paddingTop:'20px', fontWeight:'bold', paddingBottom:'10px'}}>Your Looking For (Will show other owned racers):</div>
                                {currLF[0].map(function(mys, i) {
                return <div key={i} ><hr /><div className='row'><div className='col'>Creature: {mys.creature}</div><div className='col'>Skin: {mys.skin}</div><div className='col'>Dated Added: {mys.date}</div><div className='col'><input type="button" value="Remove" onClick={() => remLookingFor(mys.id)} /></div></div>
           <div className='row'>
            {allRacers.filter(x => (mys.creature === '' ? x.Creature !== '' : x.Creature === mys.creature)  && (mys.skin === '' ? x.Phant_Skin !== '' : x.Phant_Skin === mys.skin) && racerArray.filter(y => y.id === parseInt(x.ID)).length === 0).map(function(me,x){
                        return <div className="col-2" style={{minWidth:'80px'}} key={x} >
                        
                                <div >
                                <div className="img-con">
                                    <img src={'https://oceanracingleague.com/collections/racers/small/'+me.ID +'.png'} style={{maxWidth:'100px'}} alt="EOR racer"></img>
                                    <span className="floating"><a href={'https://opensea.io/assets/matic/0x72106bbe2b447ecb9b52370ddc63cfa8e553b08c/'+me.ID } alt="opensea" target="_blank" rel="noreferrer" style={{color:'white'}}>#{me.ID }</a></span>
                                </div>
                                </div>
                                
                                </div>
                        })}
                        </div>
                        </div>
            })}
            <div style={{paddingTop:'20px', fontWeight:'bold'}}>Others Looking For(Will show your owned racers):</div>
            {currLF[1].map(function(mys, i) {
                return <div key={i} ><hr /><div className='row'><div className='col'>Creature: {mys.creature}</div><div className='col'>Skin: {mys.skin}</div><div className='col'>Team: {mys.teamname}</div><div className='col'>Dated Added: {mys.date}</div></div>
                {allRacers.filter(x => (mys.creature === '' ? x.Creature !== '' : x.Creature === mys.creature)  && (mys.skin === '' ? x.Phant_Skin !== '' : x.Phant_Skin === mys.skin) && racerArray.filter(y => y.id === parseInt(x.ID)).length > 0).map(function(me,x){
                            return <div className="col-2" style={{minWidth:'80px'}} key={x} >
                            
                                    <div >
                                    <div className="img-con">
                                        <img src={'https://oceanracingleague.com/collections/racers/small/'+me.ID +'.png'} alt="EOR racer"></img>
                                        <span className="floating"><a href={'https://opensea.io/assets/matic/0x72106bbe2b447ecb9b52370ddc63cfa8e553b08c/'+me.ID } alt="opensea" target="_blank" rel="noreferrer" style={{color:'white'}}>#{me.ID }</a></span>
                                    </div>
                                    </div>
                                    </div>
                            })}
                            </div>
                
            })}
        </div>
    )

}


export {LookingFor};